import { useEffect, useState } from "react";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./ProfileManagement.module.css";
import { RiUserLine } from "react-icons/ri";
import EditKidProfile from "./EditKidProdile";
import TabBar from "components/tabBar/TabBar";
import ProfileForm from "components/profileForm/costumerProfileForm";
import { useNavigate } from "react-router-dom";
import { getParentKids } from "services/get-parents-kids";
import { checkSession } from "services/userLogin/check-session";
import { getProfileInfo } from "services/profileManegement/get-profile-info";
import { KidsData } from "modules/profile";


export default function ProfileManagement() {
    const navigate = useNavigate();
    const [kidsData, setKidsData] = useState<KidsData[]>([]);
    const tabs = [
        { id: "myData", label: "Meine Daten" },
        { id: "kids", label: `Kinder (${kidsData.length})` },
    ];

    const fetchData = async () => {
        try {
            const kidsDataRes = await getParentKids();
            const filteredKids = (kidsDataRes.kids || []).filter((kid: KidsData) => !kid.isArchived);
            setKidsData(filteredKids)
        } catch (error) {
            console.error("Fehler beim Laden von Daten:", error);
        }
    };


    const [activeTab, setActiveTab] = useState<string>(tabs[0].id);
    const [initialValues, setInitialValues] = useState({
        first_name: "",
        last_name: "",
        country: "",
        phone: "",
        zip: "",
        city: "",
        street: "",
        status: "",
        faculty: "",
        account_holder: "",
        iban: "",
        bic: "",
        emergencyContacts: [{ name: '', phone: '' }],
    });
    const [currentValues, setCurrentValues] = useState(initialValues);

    const verifySession = async () => {
        try {
            const sessionData = await checkSession();
            if (sessionData.session_active) {
                const { is_customer, is_employee, is_statistic } = sessionData.user_data;
                if (!is_customer && is_employee) {
                    if (is_statistic) {
                        navigate('/reservierungsportal/StatisticPage', { replace: true });

                    } else {
                        navigate('/reservierungsportal/EmployHomePage', { replace: true });
                    }
                } else if (is_customer) {
                    const profileData = await getProfileInfo();
                    if (profileData.success) {
                        setInitialValues(profileData.profile);
                        setCurrentValues(profileData.profile);
                    }
                }
            } else {
                navigate('/reservierungsportal', { replace: true });
            }
        } catch (error) {
            console.error("Fehler bei der Sitzungsprüfung:", error);
        }
    };

    useEffect(() => {
        verifySession();
        fetchData();
    }, []);

    const handleTabClick = (tabId: string) => {
        setActiveTab(tabId);
    };

    return (
        <div className={styles.container}>
            <div className={`${commonStyles.sectionTitle} ${styles.sectionTitle}`}>
                <RiUserLine className={commonStyles.sectionTitleIcon} />
                <h1>Mein Profil</h1>
            </div>

            <TabBar tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />

            <div className={styles.tabContent}>
                {activeTab === "myData" && (
                    <ProfileForm
                        initialValues={currentValues}
                        buttonOptions={[
                            {
                                label: "Abbrechen",
                                onClick: () => {
                                    verifySession();
                                },
                            },
                            {
                                label: "Speichern",
                            },
                        ]}
                        onSubmitSuccess={() => {
                            setInitialValues(currentValues);
                        }}
                    />
                )}
                {activeTab === "kids" && <EditKidProfile kidsData={kidsData} onRefreshKids={fetchData} />}
            </div>
        </div>
    );
}
